module.exports = __webpack_public_path__ + "static/media/texture-img.5b740e39.png";